import React, { useState, useRef, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { withNamespaces } from 'react-i18next';
import { Avatar, Collapsible } from 'grommet';
import { Box, ButtonNew, Text, Image } from 'components/Wrapped';
import { useSelector } from 'react-redux';
import styles from './TopBar.module.scss';

const AuthenticatedNav = ({ topNav, t: translate, sideNav = false, enableDSSO, mgokx }) => {
  // const t = nestedTranslate(translate, 'navbar.links');
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);
  const buttonRef = useRef(null);
  const profile = useSelector((state) => state.user.profile);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (open && !menuRef?.current?.contains(event.target) && !buttonRef?.current?.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [open]);

  const handleMenuItemClick = () => {
    setOpen(false);
  };

  return (
    <React.Fragment>
      <Link to="/wallet" color="white">
        <ButtonNew label="Активы" theme="green" margin={{ right: '8px' }} />
      </Link>

      {/* <ButtonNew
        theme="black"
        label={<Image src="/assets/img/icons/bell.svg" />}
        width="40px"
        height="40px"
        margin={{ right: '8px' }}
      /> */}
      <Box forwardRef={buttonRef} pad="none" height="40px" width="40px" style={{ cursor: 'pointer' }} onClick={() => setOpen(!open)}>
        <Avatar src="/assets/img/icons/profile.svg" />
      </Box>
      <Box
        forwardRef={menuRef}
        pad="none"
        style={{
          position: 'absolute',
          top: '55px',
          right: '10px',
          width: '260px',
          overflowX: 'hidden',
          zIndex: 10,
        }}
        className={styles.authenticatedNavContainer}
      >
        <Collapsible open={open}>
          <Box
            background="#121E25"
            border={{
              color: '#38444A',
              size: '1px',
              style: 'solid',
              side: 'all',
            }}
            round="16px"
            pad="none"
            width="260px"
            className={styles.authenticatedNavContainer}
          >
            <Box
              border={{
                color: '#38444A',
                size: '1px',
                style: 'solid',
                side: 'bottom',
              }}
              gap="8px"
              pad={{ horizontal: '8px', top: '8px', bottom: '8px' }}
              style={{ minHeight: '85px' }}
            >
              <Box align="center" direction="row" gap="10px" pad={{ horizontal: '12px', vertical: '14px' }}>
                <Box pad="none" height="40px" width="40px">
                  <Avatar src="/assets/img/icons/profile.svg" />
                </Box>
                <Box pad="none">
                  <Text weight={600} style={{ lineHeight: '17px', wordBreak: 'break-word' }}>
                    {profile?.email}
                  </Text>
                  <Text color="#B4B6B7" weight={500} style={{ lineHeight: '17px' }}>
                    UID: {profile?.customerID}
                  </Text>
                </Box>
              </Box>
              {/* <Box pad={{ horizontal: '12px', vertical: '0px' }}>
                <ButtonNew label="Переключить счет" theme="gray" />
              </Box> */}
            </Box>

            <Box
              border={{
                color: '#38444A',
                size: '1px',
                style: 'solid',
                side: 'bottom',
              }}
              pad={{ horizontal: '8px', vertical: '12px' }}
              style={{ minHeight: '140px' }}
            >
              <Link to="/account" color="white">
                <Box
                  align="center"
                  direction="row"
                  round="12px"
                  gap="10px"
                  pad={{ horizontal: '8px', vertical: '8px' }}
                  className={styles.personalAccountItem}
                  onClick={handleMenuItemClick}
                >
                  <Box pad="none" height="24px" width="24px">
                    <Image src="/assets/img/icons/user.svg" />
                  </Box>
                  <Text weight={600} style={{ lineHeight: '17px', color: 'white' }}>
                    Мой аккаунт
                  </Text>
                </Box>
              </Link>
              <Link to="/wallet" color="white">
                <Box
                  align="center"
                  direction="row"
                  round="12px"
                  gap="10px"
                  pad={{ horizontal: '8px', vertical: '8px' }}
                  className={styles.personalAccountItem}
                  onClick={handleMenuItemClick}
                >
                  <Box pad="none" height="24px" width="24px">
                    <Image src="/assets/img/icons/act.svg" />
                  </Box>
                  <Text weight={600} style={{ lineHeight: '17px', color: 'white' }}>
                    Активы
                  </Text>
                </Box>
              </Link>
              <Link to="/trade/USDT-RUB">
                <Box
                  align="center"
                  direction="row"
                  round="12px"
                  gap="10px"
                  pad={{ horizontal: '8px', vertical: '8px' }}
                  className={styles.personalAccountItem}
                  onClick={handleMenuItemClick}
                >
                  <Box pad="none" height="24px" width="24px">
                    <Image src="/assets/img/icons/chart.svg" />
                  </Box>
                  <Text weight={600} style={{ lineHeight: '17px', color: 'white' }}>
                    Ордера
                  </Text>
                </Box>
              </Link>
            </Box>

            <Box
              border={{
                color: '#38444A',
                size: '1px',
                style: 'solid',
                side: 'bottom',
              }}
              pad={{ horizontal: '8px', vertical: '12px' }}
              style={{ minHeight: '65px' }}
            >
              {/* <Box
                align="center"
                direction="row"
                round="12px"
                gap="10px"
                pad={{ horizontal: '12px', vertical: '14px' }}
                className={styles.personalAccountItem}
                onClick={handleMenuItemClick}
              >
                <Box pad="none" height="24px" width="24px">
                  <Image src="/assets/img/icons/diamond.svg" />
                </Box>
                <Text weight={600} style={{ lineHeight: '17px' }}>
                  Реферальная программа
                </Text>
              </Box> */}
              <a href="https://t.me/ibex" target="_blank" rel="noopener noreferrer" style={{ color: 'inherit' }}>
                <Box
                  align="center"
                  direction="row"
                  round="12px"
                  gap="10px"
                  pad={{ horizontal: '8px', vertical: '8px' }}
                  className={styles.personalAccountItem}
                  onClick={handleMenuItemClick}
                >
                  <Box pad="none" height="24px" width="24px">
                    <Image src="/assets/img/icons/chat.svg" />
                  </Box>
                  <Text weight={600} style={{ lineHeight: '17px' }}>
                    Поддержка
                  </Text>
                </Box>
              </a>
              {/* <Box
                align="center"
                direction="row"
                round="12px"
                gap="10px"
                pad={{ horizontal: '12px', vertical: '14px' }}
                className={styles.personalAccountItem}
                onClick={handleMenuItemClick}
              >
                <Box pad="none" height="24px" width="24px">
                  <Image src="/assets/img/icons/code.svg" />
                </Box>
                <Text weight={600} style={{ lineHeight: '17px' }}>
                  Api
                </Text>
              </Box> */}
            </Box>
            <Box pad={{ horizontal: '8px', vertical: '12px' }} style={{ minHeight: '65px' }}>
              <NavLink to="/logout">
                <Box
                  align="center"
                  direction="row"
                  round="12px"
                  gap="10px"
                  pad={{ horizontal: '8px', vertical: '8px' }}
                  className={styles.personalAccountItem}
                >
                  <Box pad="none" height="24px" width="24px">
                    <Image src="/assets/img/icons/quit.svg" />
                  </Box>
                  <Text color="white" weight={600} style={{ lineHeight: '17px' }}>
                    Выход
                  </Text>
                </Box>
              </NavLink>
            </Box>
          </Box>
        </Collapsible>
      </Box>
      {/* {enableDSSO && (
        <NavbarItem
          to="/derivatives"
          // navIcon={require('assets/icons/person.svg')}
        >
          {t('derivatives')}
        </NavbarItem>
      )} */}
      {/* <NavbarItem
        to="/account"
        // navIcon={require('assets/icons/person.svg')}
      >
        {t('account')}
      </NavbarItem> */}
      {/* {mgokx?.wallet_page && (
        <React.Fragment>
          <NavbarItem
            to="/orders"
            // navIcon={require('assets/icons/search.svg')}
          >
            {t('orders')}
          </NavbarItem>

          <NavbarItem
            to="/wallet"
            // navIcon={require('assets/icons/wallet.svg')}
          >
            {t('wallet')}
          </NavbarItem>
        </React.Fragment>
      )} */}
      {/* {mgokx?.enabled && (
        <NavbarItem
          to="/NDWallet"
          // navIcon={require('assets/icons/person.svg')}
        >
          {t('NDWallet')}
        </NavbarItem>
      )} */}
      {/* {!!topNav && (
        <Link to="/logout">
          <Button
            color="primary"
            primary={false}
            margin={{ horizontal: '8px' }}
            {...buttonProps}
          >
            {t('logout')}
          </Button>
        </Link>
      )} */}
    </React.Fragment>
  );
};

export default withNamespaces()(AuthenticatedNav);
